/**
 * Nextcloud Cookbook app
 * Event bus module
 * ----------------------
 * @license AGPL3 or later
 */
import mitt from 'mitt';

const emitter = mitt();

export default emitter;
